import type { FC } from 'react';

import { cn } from '@repo/utils/common';

import { HEADER_HEIGHT_CLASS } from '@/shared/configs/toolbar.config';

import { CartButton } from '@/components/common/CartButton';
import { Container } from '@/components/common/Container';
import { BrandLockup } from '@/components/toolbar/BrandLockup';
import { PartnerPortalLink } from '@/components/toolbar/PartnerPortalLink';

export const Header: FC = () => (
  <header className="bg-secondary text-secondary-foreground">
    <Container className={cn('flex items-center justify-between', HEADER_HEIGHT_CLASS)}>
      <BrandLockup />
      <div className="flex items-center gap-4 md:gap-6">
        <CartButton />
        <PartnerPortalLink />
      </div>
    </Container>
  </header>
);
